// import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import _this from '../main.js';

const Index = r => require.ensure([], () => r(require('@/components/index')), 'index')
const Shouye = r => require.ensure([], () => r(require('@/components/index/index')), 'index')
const Login = r => require.ensure([], () => r(require('@/components/index/login')), 'login')
const Register = r => require.ensure([], () => r(require('@/components/index/register')), 'Register')
const Info = r => require.ensure([], () => r(require('@/components/index/info')), 'Info')
const Question = r => require.ensure([], () => r(require('@/components/index/question')), 'Info')

//忘记密码
const ForgetPassword = r => require.ensure([], () => r(require('@/components/forgetPassword/forgetPassword')), 'ForgetPassword')
const ForgetPasswordList = r => require.ensure([], () => r(require('@/components/forgetPassword/forgetPasswordList')), 'ForgetPasswordList')
const ForgetPasswordEmail = r => require.ensure([], () => r(require('@/components/forgetPassword/forgetPasswordEmail')), 'ForgetPasswordEmail')
const ForgetPasswordPhone = r => require.ensure([], () => r(require('@/components/forgetPassword/forgetPasswordPhone')), 'ForgetPasswordPhone')

//费用
const Cost = r => require.ensure([], () => r(require('@/components/cost/index')), 'Cost')

//续费
const Renew = r => require.ensure([], () => r(require('@/components/renew/index')), 'Renew')
const RenewECSList = r => require.ensure([], () => r(require('@/components/renew/ECSList')), 'RenewECS')
const RenewECS = r => require.ensure([], () => r(require('@/components/renew/ECS')), 'RenewECS')
const RenewRDS = r => require.ensure([], () => r(require('@/components/renew/RDS')), 'RenewRDS')
const RenewRDSList = r => require.ensure([], () => r(require('@/components/renew/RDSList')), 'RenewRDS')
const RenewSLB = r => require.ensure([], () => r(require('@/components/renew/SLB')), 'RenewSLB')
const RenewSLBList = r => require.ensure([], () => r(require('@/components/renew/SLBList')), 'RenewSLB')
const RenewEIP = r => require.ensure([], () => r(require('@/components/renew/EIP')), 'RenewEIP')
const RenewEIPList = r => require.ensure([], () => r(require('@/components/renew/EIPList')), 'RenewEIP')

//用户中心
const UserData = r => require.ensure([], () => r(require('@/components/personalCenter/userData')), 'useCenter')
const ModifyPassword = r => require.ensure([], () => r(require('@/components/personalCenter/modifyPassword')), 'ModifyPassword')
const ModifyPasswordList = r => require.ensure([], () => r(require('@/components/personalCenter/modifyPasswordList')), 'ModifyPasswordList')
const ModifyPasswordPhone = r => require.ensure([], () => r(require('@/components/personalCenter/modifyPasswordPhone')), 'ModifyPasswordPhone')
const ModifyPasswordEmail = r => require.ensure([], () => r(require('@/components/personalCenter/modifyPasswordEmail')), 'ModifyPasswordEmail')
const Authentication = r => require.ensure([], () => r(require('@/components/personalCenter/authentication')), 'Authentication')
const UserSecurityaccount = r => require.ensure([], () => r(require('@/components/personalCenter/userSecurityaccount')), 'UserSecurityaccount')
const ModifyPhone = r => require.ensure([], () => r(require('@/components/personalCenter/modifyPhone')), 'ModifyPhone')

//支付
const Prepay = r => require.ensure([], () => r(require('@/components/payment/prepay')), 'payment')
//合并支付
const MultiplePrepay = r => require.ensure([], () => r(require('@/components/payment/multiplePrepay')), 'multiplePrepay')
//支付跳转
const Paying = r => require.ensure([], () => r(require('@/components/payment/paying')), 'payment')
const PaySuccess = r => require.ensure([], () => r(require('@/components/payment/paySuccess')), 'payment')

//个人充值
const Recharge = r => require.ensure([], () => r(require('@/components/payment/recharge')), 'reCharge')

//支付宝充值
const Alipay = r => require.ensure([], () => r(require('@/components/payment/alipay')), 'Alipay')

//订单
const Order = r => require.ensure([], () => r(require('@/components/order/index')), 'order')
const OrderList = r => require.ensure([], () => r(require('@/components/order/list')), 'order')
const OrderDetail = r => require.ensure([], () => r(require('@/components/order/detail')), 'order')

//收支明细
const ChargeList = r => require.ensure([], () => r(require('@/components/charge/consumption/list')), 'charge')
//账户总览
const Overview = r => require.ensure([], () => r(require('@/components/charge/overview')), 'overview')


//发票
const Invoice = r => require.ensure([], () => r(require('@/components/invoice/index')), 'invoice')
const HeadInfoInvoice = r => require.ensure([], () => r(require('@/components/invoice/editHeadInfo')), 'invoice')
const InvoiceAddressList = r => require.ensure([], () => r(require('@/components/invoice/listAddress')), 'InvoiceAddress')
const InvoiceBill = r => require.ensure([], () => r(require('@/components/invoice/invoiceBill')), 'InvoiceBill')
const InvoiceAskFor = r => require.ensure([], () => r(require('@/components/invoice/askForInvoice')), 'InvoiceBill')
const InvoiceList = r => require.ensure([], () => r(require('@/components/invoice/listInvoice')), 'InvoiceList')
const InvoiceDetail = r => require.ensure([], () => r(require('@/components/invoice/detail')), 'InvoiceDetail')
const InvoiceAskForAddressUpdate = r => require.ensure([], () => r(require('@/components/invoice/askForupdateAddress')), 'InvoiceBill')
const InvoiceInfoShow = r => require.ensure([], () => r(require('@/components/invoice/showInvoiceInfo')), 'invoice')

//工单
const WorkOrder = r => require.ensure([], () => r(require('@/components/workOrder/index')), 'WorkOrder')
const WorkOrderList = r => require.ensure([], () => r(require('@/components/workOrder/list')), 'WorkOrderList')
const WorkOrderDetail = r => require.ensure([], () => r(require('@/components/workOrder/detail')), 'WorkOrderDetail')
const WorkOrderSubmit = r => require.ensure([], () => r(require('@/components/workOrder/submit')), 'WorkOrderSubmit')

//私有网路
const PrivateNetwork = r => require.ensure([], () => r(require('@/components/privateNetwork/index')), 'PrivateNetwork')
const PrivateNetworkList = r => require.ensure([], () => r(require('@/components/privateNetwork/list')), 'PrivateNetworkList')
const PrivateNetworkCreate = r => require.ensure([], () => r(require('@/components/privateNetwork/create')), 'PrivateNetworkCreate')
const PrivateNetworkDetail = r => require.ensure([], () => r(require('@/components/privateNetwork/detail')), 'PrivateNetworkDetail')
const PrivateNetworkDetailInfo = r => require.ensure([], () => r(require('@/components/privateNetwork/info')), 'PrivateNetworkDetailInfo')
const PrivateNetworkDetailNetwork = r => require.ensure([], () => r(require('@/components/privateNetwork/network')), 'PrivateNetworkDetailNetwork')
const PrivateNetworkDetailDNS = r => require.ensure([], () => r(require('@/components/privateNetwork/DNS')), 'PrivateNetworkDetailDNS')
const PrivateNetworkDetailHost = r => require.ensure([], () => r(require('@/components/privateNetwork/host')), 'PrivateNetworkDetailHost')

//云路由
const CloudRouter = r => require.ensure([], () => r(require('@/components/cloudRouter/index')), 'CloudRouter')
const CloudRouterSize = r => require.ensure([], () => r(require('@/components/cloudRouter/routerSize')), 'CloudRouterSize')
const CloudRouterSizeCreate = r => require.ensure([], () => r(require('@/components/cloudRouter/routerSizeCreate')), 'CloudRouterSizeCreate')
const CloudRouterEquipment = r => require.ensure([], () => r(require('@/components/cloudRouter/routerEquipment')), 'CloudRouterEquipment')

//云主机
const Host = r => require.ensure([], () => r(require('@/components/host/index')), 'Host')
const HostList = r => require.ensure([], () => r(require('@/components/host/list')), 'HostList')
const HostCreate = r => require.ensure([], () => r(require('@/components/host/create')), 'HostCreate')
const HostDetail = r => require.ensure([], () => r(require('@/components/host/detail')), 'HostDetail')
const HostDetailSnapshot = r => require.ensure([], () => r(require('@/components/host/snapshot')), 'HostDetailSnapshot')
const HostDetailInfo = r => require.ensure([], () => r(require('@/components/host/info')), 'HostDetailInfo')
const HostDetailImage = r => require.ensure([], () => r(require('@/components/host/image')), 'HostDetailImage')
const HostDetailDisk = r => require.ensure([], () => r(require('@/components/host/disk')), 'HostDetailDisk')

//云盘
const Disk = r => require.ensure([], () => r(require('@/components/disk/index')), 'Disk')
const DiskList = r => require.ensure([], () => r(require('@/components/disk/list')), 'DiskList')
const DiskCreate = r => require.ensure([], () => r(require('@/components/disk/create')), 'DiskCreate')
const DiskDetail = r => require.ensure([], () => r(require('@/components/disk/detail')), 'DiskDetail')
const DiskDetailSnapshot = r => require.ensure([], () => r(require('@/components/disk/snapshot')), 'DiskDetailSnapshot')
const DiskDetailInfo = r => require.ensure([], () => r(require('@/components/disk/info')), 'DiskDetailInfo')

//镜像
const Images = r => require.ensure([], () => r(require('@/components/image/index')), 'Images')
const ImagesList = r => require.ensure([], () => r(require('@/components/image/list')), 'ImagesList')
const ImagesDetail = r => require.ensure([], () => r(require('@/components/image/detail')), 'ImagesDetail')

//快照
const Snapshot = r => require.ensure([], () => r(require('@/components/snapshot/index')), 'Snapshot')
const SnapshotList = r => require.ensure([], () => r(require('@/components/snapshot/list')), 'SnapshotList')
const SnapshotDetail = r => require.ensure([], () => r(require('@/components/snapshot/detail')), 'SnapshotDetail')

//安全组
const SecurityGroup = r => require.ensure([], () => r(require('@/components/securityGroup/index')), 'SecurityGroup')
const SecurityGroupList = r => require.ensure([], () => r(require('@/components/securityGroup/list')), 'SecurityGroupList')
const SecurityGroupCreate = r => require.ensure([], () => r(require('@/components/securityGroup/create')), 'SecurityGroupCreate')
const SecurityGroupDetail = r => require.ensure([], () => r(require('@/components/securityGroup/detail')), 'SecurityGroupDetail')
const SecurityGroupRules = r => require.ensure([], () => r(require('@/components/securityGroup/rules')), 'SecurityGroupRules')
const SecurityGroupNetwork = r => require.ensure([], () => r(require('@/components/securityGroup/networkCard')), 'SecurityGroupNetwork')
const SecurityGroupNetworkCard = r => require.ensure([], () => r(require('@/components/securityGroup/network')), 'SecurityGroupNetworkCard')

//vip
const VIP = r => require.ensure([], () => r(require('@/components/vip/index')), 'VIP')
const VIPList = r => require.ensure([], () => r(require('@/components/vip/list')), 'VIPList')
const VIPCreate = r => require.ensure([], () => r(require('@/components/vip/create')), 'VIPCreate')

//eip
const EIP = r => require.ensure([], () => r(require('@/components/eip/index')), 'EIP')
const EIPList = r => require.ensure([], () => r(require('@/components/eip/list')), 'EIPList')
const EIPCreate = r => require.ensure([], () => r(require('@/components/eip/create')), 'EIPCreate')

//slb
const SLB = r => require.ensure([], () => r(require('@/components/slb/index')), 'SLB')
const SLBList = r => require.ensure([], () => r(require('@/components/slb/list')), 'SLBList')
const SLBCreate = r => require.ensure([], () => r(require('@/components/slb/create')), 'SLBCreate')
const SLBDetail = r => require.ensure([], () => r(require('@/components/slb/detail')), 'SLBDetail')
const SLBDetailMonitor = r => require.ensure([], () => r(require('@/components/slb/monitor')), 'SLBDetailMonitor')
const SLBDetailMonitorDetail = r => require.ensure([], () => r(require('@/components/slb/monitorDetail')), 'SLBDetailMonitorDetail')

//port
const Port = r => require.ensure([], () => r(require('@/components/port/index')), 'Port')
const PortList = r => require.ensure([], () => r(require('@/components/port/list')), 'PortList')
const PortCreate = r => require.ensure([], () => r(require('@/components/port/create')), 'PortCreate')



Vue.use(Router)
let menu = '/Menu';

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/',
            component: Index,
            children: [{
                    path: '/',
                    component: Shouye,
                    name: 'Index',
                    meta: { title: '首页' }
                },
                {
                    path: '/cost',
                    component: Cost,
                    children: [
                    { path: 'overview', component: Overview, name: 'Overview', meta: { title: '账户总览' ,code:'overview'} },
                    { path: 'chargeList', component: ChargeList, name: 'ChargeList', meta: { title: '收支明细' ,code:'chargeList'} },
                    {
                        path: 'renew',
                        component: Renew,
                        children: [
                        { path: '/', component: RenewECSList, name: 'RenewECSList', meta: { title: 'ECS续费' ,code:'ECS'} },
                        { path: 'list/ECS', component: RenewECSList, name: 'RenewECSList', meta: { title: 'ECS续费' ,code:'ECS'} },
                        { path: 'ECS/:region/:id', component: RenewECS, name: 'RenewECS', meta: { title: 'ECS续费',code:'ECS' } },
                        { path: 'list/RDS', component: RenewRDSList, name: 'RenewRDSList', meta: { title: 'RDS续费' ,code:'RDS'} },
                        { path: 'RDS/:region/:id', component: RenewRDS, name: 'RenewRDS', meta: { title: 'RDS续费',code:'RDS' } },
                        { path: 'list/SLB', component: RenewSLBList, name: 'RenewSLBList', meta: { title: 'SLB续费' ,code:'SLB'} },
                        { path: 'SLB/:region/:id', component: RenewSLB, name: 'RenewSLB', meta: { title: 'SLB续费',code:'SLB' } },
                        { path: 'list/EIP', component: RenewEIPList, name: 'RenewEIPList', meta: { title: 'EIP续费' ,code:'EIP'} },
                        { path: 'EIP/:region/:id', component: RenewEIP, name: 'RenewEIP', meta: { title: 'EIP续费',code:'EIP' } },
                        ]
                    },
                    {
                        path: 'order',
                        component: Order,
                        children: [
                        { path: '/', component: OrderList, name: 'OrderList', meta: { title: '订单列表',code:'order' } },
                        { path: 'detail/:id', component: OrderDetail, name: 'OrderDetail', meta: { title: '订单详情',code:'order' } },
                        ]
                    },
                    {
                    path: 'invoice',
                    component: Invoice,
                    meta: { title: '填写发票抬头信息' },
                    children: [
                        { path: 'message', component: HeadInfoInvoice, name: 'HeadInfoInvoice', meta: { title: '发票台头信息' ,code:'message'} },
                        { path: 'address', component: InvoiceAddressList, name: 'InvoiceAddressList', meta: { title: '寄送地址中心' ,code:'address'} },
                        { path: 'bill', component: InvoiceBill, name: 'InvoiceBill', meta: { title: '索取发票' ,code:'bill'} },
                        { path: 'askfor', component: InvoiceAskFor, name: 'InvoiceAskFor', meta: { title: '发票索取' ,code:'invoiceBill'} },
                        { path: 'list', component: InvoiceList, name: 'InvoiceList', meta: { title: '发票列表' ,code:'list'} },
                        { path: 'askForModify', component: InvoiceAskForAddressUpdate, name: 'InvoiceAskForAddressUpdate', meta: { title: '更新发票地址发票列表',code:'invoiceAddress' } },
                        { path: 'detail', component: InvoiceDetail, name: 'InvoiceDetail', meta: { title: '发票详情' ,code:'invoice'} },
                        { path: 'show', component: InvoiceInfoShow, name: 'InvoiceInfoShow', meta: { title: '发票信息' ,code:'invoiceInfo'} },
                    ]
                },
                    ]
                },
                {
                    path: '/userData',
                    component: UserData,
                },
                {
                    path: '/question',
                    name: 'Question',
                    meta: { title: '密保问题' },
                    component: Question,
                },
                {
                    path: '/modifyPassword',
                    meta: { title: '修改密码' },
                    component: ModifyPassword,
                    children: [
                        { path: '/', component: ModifyPasswordList, name: 'ModifyPasswordList', meta: { title: '修改密码' } },
                        { path: 'phone', component: ModifyPasswordPhone, name: 'ModifyPasswordPhone', meta: { title: '修改密码' } },
                        { path: 'email', component: ModifyPasswordEmail, name: 'ModifyPasswordEmail', meta: { title: '修改密码' } },
                        { path: 'modifyPhone', component: ModifyPhone, name: 'ModifyPhone', meta: { title: '修改手机号' } },
                    ]
                },
                {
                    path: '/authentication',
                    name: 'Authentication',
                    meta: { title: '实名认证' },
                    component: Authentication,
                },
                {
                    path: '/userSecurityaccount',
                    name: 'UserSecurityaccount',
                    meta: { title: '账户安全' },
                    component: UserSecurityaccount,
                },
                {
                    path: '/prepay/:orderId',
                    name: 'Prepay',
                    meta: { title: '支付' },
                    component: Prepay,
                },
                {
                    path: '/multiplePrepay/:orderNoList',
                    name: 'MultiplePrepay',
                    meta: { title: '合并支付' },
                    component: MultiplePrepay,
                },
                //个人充值
                {
                    path: '/recharge',
                    name: 'Recharge',
                    meta: { title: '个人充值' },
                    component: Recharge,
                },
                {
                    path: '/workOrder',
                    component: WorkOrder,
                    children: [
                        { path: '/', component: WorkOrderList, name: 'WorkOrderList', meta: { title: '我的工单',code:'list' } },
                        { path: 'list', component: WorkOrderList, name: 'WorkOrderList', meta: { title: '我的工单',code:'list' } },
                        { path: 'detail/:id', component: WorkOrderDetail, name: 'WorkOrderDetail', meta: { title: '我的工单',code:'list' } },
                        { path: 'submit', component: WorkOrderSubmit, name: 'WorkOrderSubmit', meta: { title: '提交工单',code:'submit' } },
                    ]
                },
                {
                    path: '/privateNetwork',
                    component: PrivateNetwork,
                    children: [
                        { path: '/', component: PrivateNetworkList, name: 'PrivateNetworkList', meta: { title: '私有网络',code:'list' } },
                        { path: 'list', component: PrivateNetworkList, name: 'PrivateNetworkList', meta: { title: '私有网络',code:'list' } },
                        { path: 'create', component: PrivateNetworkCreate, name: 'PrivateNetworkCreate', meta: { title: '创建私有网络',code:'create' } },                    
                        {
                            path: 'detail/:id',
                            component: PrivateNetworkDetail,
                            children: [
                            { path: '/', component: PrivateNetworkDetailInfo, name: 'PrivateNetworkDetail', meta: { title: '私有网络',code:'info' } },
                            { path: 'info', component: PrivateNetworkDetailInfo, name: 'PrivateNetworkDetailInfo', meta: { title: '私有网络',code:'info' } },
                            { path: 'DNS', component: PrivateNetworkDetailDNS, name: 'PrivateNetworkDetailDNS', meta: { title: '私有网络',code:'DNS' } },
                            { path: 'network', component: PrivateNetworkDetailNetwork, name: 'PrivateNetworkDetailNetwork', meta: { title: '私有网络',code:'network' } },
                            { path: 'host', component: PrivateNetworkDetailHost, name: 'PrivateNetworkDetailHost', meta: { title: '私有网络',code:'host' } },
                            ]
                        },
                    ]
                },
                {
                    path: '/cloudRouterSize',
                    component: CloudRouter,
                    children: [
                        { path: '/', component: CloudRouterSize, name: 'CloudRouterSize', meta: { title: '云路由规格',code:'list' } },
                        { path: 'list', component: CloudRouterSize, name: 'CloudRouterSize', meta: { title: '云路由规格',code:'list' } },
                        { path: 'create', component: CloudRouterSizeCreate, name: 'CloudRouterSizeCreate', meta: { title: '创建云路由规格',code:'create' } },                    
                    ]
                },
                {
                    path: '/cloudRouterEquipment',
                    component: CloudRouterEquipment,
                },
                {
                    path: '/host',
                    component: Host,
                    children: [
                        { path: '/', component: HostList, name: 'HostList', meta: { title: '云主机',code:'list' } },
                        { path: 'list', component: HostList, name: 'HostList', meta: { title: '云主机',code:'list' } },
                        { path: 'create', component: HostCreate, name: 'HostCreate', meta: { title: '创建云主机',code:'create' } },                    
                        {
                            path: 'detail/:id',
                            component: HostDetail,
                            children: [
                            { path: '/', component: HostDetailInfo, name: 'HostDetail', meta: { title: '云主机详情',code:'info' } },
                            { path: 'snapshot', component: HostDetailSnapshot, name: 'HostDetailSnapshot', meta: { title: '云主机快照',code:'snapshot' } },
                            { path: 'info', component: HostDetailInfo, name: 'HostDetailInfo', meta: { title: '云主机详情',code:'info' } },
                            { path: 'image', component: HostDetailImage, name: 'HostDetailImage', meta: { title: '云主机镜像',code:'image' } },
                            { path: 'disk', component: HostDetailDisk, name: 'HostDetailDisk', meta: { title: '云主机云盘',code:'disk' } },
                            ]
                        },
                    ]
                },
                {
                    path: '/disk',
                    component: Disk,
                    children: [
                        { path: '/', component: DiskList, name: 'DiskList', meta: { title: '云盘',code:'list' } },
                        { path: 'list', component: DiskList, name: 'DiskList', meta: { title: '云盘',code:'list' } },
                        { path: 'create', component: DiskCreate, name: 'DiskCreate', meta: { title: '创建云盘',code:'create' } },                    
                        {
                            path: 'detail/:id',
                            component: DiskDetail,
                            children: [
                            { path: '/', component: DiskDetailInfo, name: 'DiskDetail', meta: { title: '云盘详情',code:'info' } },
                            { path: 'info', component: DiskDetailInfo, name: 'DiskDetailInfo', meta: { title: '云盘详情',code:'info' } },                            
                            { path: 'snapshot', component: DiskDetailSnapshot, name: 'DiskDetailSnapshot', meta: { title: '云盘快照',code:'snapshot' } },
                            ]
                        },
                    ]
                },
                {
                    path: '/images',
                    component: Images,
                    children: [
                        { path: '/', component: ImagesList, name: 'ImagesList', meta: { title: '镜像',code:'list' } },
                        { path: 'list', component: ImagesList, name: 'ImagesList', meta: { title: '镜像',code:'list' } },
                        { path: 'detail/:id', component: ImagesDetail, name: 'ImagesDetail', meta: { title: '镜像详情',code:'detail' } },
                    ]
                },
                {
                    path: '/snapshot',
                    component: Snapshot,
                    children: [
                        { path: '/', component: SnapshotList, name: 'SnapshotList', meta: { title: '快照',code:'list' } },
                        { path: 'list', component: SnapshotList, name: 'SnapshotList', meta: { title: '快照',code:'list' } },
                        { path: 'detail/:id', component: SnapshotDetail, name: 'SnapshotDetail', meta: { title: '快照详情',code:'detail' } },
                    ]
                },
                {
                    path: '/securityGroup',
                    component: SecurityGroup,
                    children: [
                        { path: '/', component: SecurityGroupList, name: 'SecurityGroupList', meta: { title: '安全组',code:'list' } },
                        { path: 'list', component: SecurityGroupList, name: 'SecurityGroupList', meta: { title: '安全组',code:'list' } },
                        { path: 'create', component: SecurityGroupCreate, name: 'SecurityGroupCreate', meta: { title: '创建安全组',code:'create' } },                    
                        {
                            path: 'detail/:id',
                            component: SecurityGroupDetail,
                            children: [
                            { path: '/', component: SecurityGroupRules, name: 'SecurityGroupDetail', meta: { title: '安全组',code:'rules' } },
                            { path: 'rules', component: SecurityGroupRules, name: 'SecurityGroupRules', meta: { title: '安全组规则',code:'rules' } },
                            { path: 'networkCard', component: SecurityGroupNetwork, name: 'SecurityGroupNetwork', meta: { title: '安全组网卡',code:'networkCard' } },
                            { path: 'network', component: SecurityGroupNetworkCard, name: 'SecurityGroupNetworkCard', meta: { title: '安全组三层网络',code:'network' } },
                            ]
                        },
                    ]
                },
                {
                    path: '/vip',
                    component: VIP,
                    children: [
                        { path: '/', component: VIPList, name: 'VIPList', meta: { title: '虚拟IP',code:'list' } },
                        { path: 'list', component: VIPList, name: 'VIPList', meta: { title: '虚拟IP',code:'list' } },
                        { path: 'create', component: VIPCreate, name: 'VIPCreate', meta: { title: '创建虚拟IP',code:'create' } },                    
                    ]
                },
                {
                    path: '/eip',
                    component: EIP,
                    children: [
                        { path: '/', component: EIPList, name: 'EIPList', meta: { title: '弹性IP',code:'list' } },
                        { path: 'list', component: EIPList, name: 'EIPList', meta: { title: '弹性IP',code:'list' } },
                        { path: 'create', component: EIPCreate, name: 'EIPCreate', meta: { title: '创建弹性IP',code:'create' } },                    
                    ]
                },
                {
                    path: '/slb',
                    component: SLB,
                    children: [
                        { path: '/', component: SLBList, name: 'SLBList', meta: { title: '负载均衡',code:'list' } },
                        { path: 'list', component: SLBList, name: 'SLBList', meta: { title: '负载均衡',code:'list' } },
                        { path: 'create', component: SLBCreate, name: 'SLBCreate', meta: { title: '创建负载均衡',code:'create' } },                    
                        {
                            path: 'detail/:id',
                            component: SLBDetail,
                            children: [
                            { path: '/', component: SLBDetailMonitor, name: 'SLBDetailMonitor', meta: { title: '负载均衡监听器',code:'monitor' } },
                            { path: 'monitor', component: SLBDetailMonitor, name: 'SLBDetailMonitor', meta: { title: '负载均衡监听器',code:'monitor' } },
                            { path: 'list', component: SLBDetailMonitorDetail, name: 'SLBDetailMonitorDetail', meta: { title: '负载均衡监听器网卡',code:'list' } },
                            ]
                        },
                    ]
                },
                {
                    path: '/port',
                    component: Port,
                    children: [
                        { path: '/', component: PortList, name: 'PortList', meta: { title: '端口转发',code:'list' } },
                        { path: 'list', component: PortList, name: 'PortList', meta: { title: '端口转发',code:'list' } },
                        { path: 'create', component: PortCreate, name: 'PortCreate', meta: { title: '创建端口转发',code:'create' } },                    
                    ]
                },
            ]

        },
        {
            path: '/login',
            name: 'Login',
            meta: { title: '登录' },
            component: Login,
        },
        {
            path: '/Register',
            name: 'Register',
            meta: { title: '注册' },
            component: Register,
        },
        {
            path: '/forgetPassword',
            meta: { title: '找回密码' },
            component: ForgetPassword,
            // children: [
            //     { path: '/', component: ForgetPasswordList, name: 'ForgetPasswordList', meta: { title: '修改密码' } },
            //     { path: 'phone', component: ForgetPasswordPhone, name: 'ForgetPasswordPhone', meta: { title: '修改密码' } },
            //     { path: 'email', component: ForgetPasswordEmail, name: 'ForgetPasswordEmail', meta: { title: '修改密码' } },
            // ]
        },
        {
            path: '/forgetPassword/email',
            meta: { title: '修改密码' },
            component: ForgetPasswordEmail,
            name: 'ForgetPasswordEmail'
        },
        {
            path: '/Info',
            name: 'Info',
            meta: { title: '初始化' },
            component: Info,
        },
        {
            path: '/userData',
            name: 'UserData',
            meta: { title: '用户资料' },
            component: UserData,
        },
        {
            path: '/paying',
            name: 'paying',
            meta: { title: '支付' },
            component: Paying,
        },
        {
            path: '/paySuccess',
            name: 'paySuccess',
            meta: { title: '支付成功' },
            component: PaySuccess,
        },
        {
            path: '/alipay',
            name: 'Alipay',
            meta: { title: '支付宝充值' },
            component: Alipay,
        },
        {
            path: "*",
            redirect: "/"
        }

    ]
})
router.beforeEach((to, from, next) => {
    if (COOKIE.get('token')) {
        store.state.loginUserMenu = JSON.parse(window.localStorage.getItem('menu'))
        store.state.loginInfo = JSON.parse(window.localStorage.getItem('info'))
        store.state.userEmail = window.localStorage.getItem('userEmail')
        store.commit('updateLoadingStatus', {isLoading: true})
        let token = COOKIE.get('token')
        let tokenList = token.split('.');
        let session=JSON.parse(BASE64.decoder(tokenList[1])).zstackSessionId
        if(!session){
            return
        }
        if (to.path == '/login') {
            if (to.meta.title) {
                document.title = to.meta.title
            }
            next('/');
        }else if(window.localStorage.getItem('initialization')=='false'){
            if (to.path == '/Info') {
                if (to.meta.title) {
                    document.title = to.meta.title
                }
                next();
            }else{
                if (to.meta.title) {
                    document.title = to.meta.title
                }
                next({path: '/Info'})
            }
        }
        else {
            if (to.meta.title) {
                document.title = to.meta.title
            }
            next({query:to.query})
        }
    } else {
        if (to.path == '/login') { //如果是登录页面路径，就直接next()
            if (to.meta.title) {
                document.title = to.meta.title
            }
            next({query:to.query});
        } else if (to.path == '/Register') {
            if (to.meta.title) {
                document.title = to.meta.title
            }
            next();
        }else if (to.path == '/forgetPassword') {
            if (to.meta.title) {
                document.title = to.meta.title
            }
            next();
        }else if (to.path == '/forgetPassword/phone') {
            if (to.meta.title) {
                document.title = to.meta.title
            }
            next();
        }else if (to.path == '/forgetPassword/email') {
            if (to.meta.title) {
                document.title = to.meta.title
            }
            next();
        } else if (Object.keys(to.query).length>0) { //如果带参就带参跳转
            next({ path: '/login',query:to.query })
        } else { //不然就跳转到登录；
            if (to.meta.title) {
                document.title = to.meta.title
            }
            if(to.fullPath =='/'){
                next('/login')
            }else{
                next({ path: '/login',query:{callback:to.fullPath} })
            }
        }
    }
})

router.afterEach(function (to) {
  store.commit('updateLoadingStatus', {isLoading: false})
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js